import { render, staticRenderFns } from "./SupportEdit.vue?vue&type=template&id=09bf8f4e&scoped=true&"
import script from "./SupportEdit.vue?vue&type=script&lang=js&"
export * from "./SupportEdit.vue?vue&type=script&lang=js&"
import style0 from "./SupportEdit.vue?vue&type=style&index=0&id=09bf8f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf8f4e",
  null
  
)

export default component.exports